import React from 'react';
import PropTypes from 'prop-types';
import { classOfServiceShape, productsShape } from 'constants/propTypes';
import InventoryClassMessage from './InventoryClassMessage';
import RebookMessage from './RebookMessage';
import RefundMessage from './RefundMessage';

const AfterSalesSummaryBox = ({
  direction: {
    origin: { timezone },
    bookingItems,
    classOfService
  },
  selectedProduct,
  refundableNCORules
}) => {
  const nonCancelledBookingItems = bookingItems.filter((bi) => bi.cancelled === false && bi.provisional === false);
  const nonCancelledBookingItem = nonCancelledBookingItems[0];
  const selectedBookingItem = nonCancelledBookingItems.filter((e) => e.productFamily?.familyGroupName === selectedProduct).shift();
  const bookingItem = selectedBookingItem || nonCancelledBookingItem || bookingItems[0];

  const canLookupMessage = bookingItem.canBeCancelled && bookingItem.canBeRefunded;
  const canBeCancelled = bookingItem.canBeCancelled;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        margin: '10px 0 8px'
      }}
    >
      <InventoryClassMessage name={bookingItem.name} classOfService={classOfService?.name} />
      <RebookMessage
        canBeRebooked={bookingItem.canBeRebooked}
        afterSalesRules={bookingItem.afterSalesRules}
        isRebookOFEActive={bookingItem.isRebookOFEActive}
        timezone={timezone}
        currency={bookingItem.currency}
      />
      <RefundMessage
        canLookupRefundMessage={canLookupMessage}
        afterSalesRules={bookingItem.afterSalesRules}
        isCancelOFEActive={bookingItem.isCancelOFEActive}
        timezone={timezone}
        currency={bookingItem.currency}
        canBeCancelled={canBeCancelled}
        refundableNCORules={refundableNCORules}
      />
    </div>
  );
};

AfterSalesSummaryBox.propTypes = {
  direction: PropTypes.shape({
    origin: PropTypes.shape({
      timezone: PropTypes.string
    }),
    bookingItems: productsShape,
    classOfService: classOfServiceShape
  }),
  selectedProduct: PropTypes.string,
  refundableNCORules: PropTypes.bool
};

export default AfterSalesSummaryBox;
